import moment from 'moment'
import i18n from '@/i18n/i18n'

const formatTime = (time:string, format:string) => {
    return moment(time, format).format(format)
}

export default formatTime